import React, { createContext, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';

const LanguagesContext = createContext();

export const useLanguages = () => {
    return useContext(LanguagesContext);
};

export const LanguagesProvider = ({ children }) => {
    const { t, i18n } = useTranslation();
    const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
        setCurrentLanguage(language);
    };

    const value = {
        currentLanguage,
        changeLanguage,
        t,
        isRTL: currentLanguage === 'ar', // For RTL languages support
        availableLanguages: ['fr', 'ar', 'en'] // Add or modify languages as needed
    };

    return (
        <LanguagesContext.Provider value={value}>
            {children}
        </LanguagesContext.Provider>
    );
};
